import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as moviesSubCategoriesModel from './model'

export function Title(): JSX.Element {
  return <AppTitle t='movies_subcategories' />
}

const skin = era.skin('routes/movies/subcategories')

MovieSubCategoriesPage.displayName = 'MovieSubCategoriesPage'
export function MovieSubCategoriesPage(): JSX.Element {
  const isContentLoading = useUnit(moviesSubCategoriesModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <Skeleton pageType='category' isLoading={isContentLoading}>
          <ui.RenderSkin name='pageTitleMovies' />
          <ui.RenderSkin name='vodsCategorySubcategories' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
